/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Secret_Keep_HintInputs */



/**
* | output |
* | --- |
* | "Leave empty to keep the stored credential." |
*
* @param {Integrations_Apis_Secret_Keep_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_secret_keep_hint = /** @type {((inputs?: Integrations_Apis_Secret_Keep_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Secret_Keep_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Leer lassen, um die gespeicherten Zugangsdaten zu behalten.")
	return /** @type {LocalizedString} */ ("Leave empty to keep the stored credential.")
});